import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '../../../environments/environments';

@Injectable({ providedIn: 'root'})

export class UserService {

  private readonly API =
    `${environment.apiUrl}/users`;

  constructor(
    private http: HttpClient
  ) {}

  createUser(
    user: any
  ): Observable<any> {
    return this.http.post(
      this.API,
      user
    );

  }

  findAll(): Observable<any[]> {
    return this.http.get<any[]>(
      this.API
    );

  }

  findById(id: string): Observable<any> {
    return this.http.get<any>(
      `${this.API}/${id}`
    );

  }

  updateUser(
    id: string,
    user: any

  ): Observable<any> {

    return this.http.put(
      `${this.API}/${id}`,
      user

    );

  }

  deleteUser(
    id: string
  ): Observable<void> {
    return this.http.delete<void>(

      `${this.API}/${id}`

    );

  }

  restoreUser(
    id: string
  ): Observable<void> {

    return this.http.patch<void>(

      `${this.API}/${id}/restore`,

      {}

    );

  }

}